import Logo from "./Logo";

const Footer = () => (
  <footer id="site-footer" className="border-t border-border bg-muted/40 py-14">
    <div className="container reading-column px-6 text-center text-sm text-foreground/80">
      {/* Brand + tagline */}
      <p className="font-serif text-xl text-foreground">Eliza Reed Wellness</p>
      <p className="mt-1 font-script text-lg text-primary">
        Gentle words for women over 45.
      </p>

      {/* Disclaimer */}
      <div className="mt-8 space-y-1">
        <p className="italic">This is not medical advice.</p>
        <p>
          Please consult your doctor before changing your diet, exercise, or daily routine.
        </p>
      </div>

      {/* Privacy line */}
      <p className="mt-8 leading-relaxed">
        Your name and email are used only to send you occasional gentle notes from Eliza.
        Never sold. Never shared. Unsubscribe anytime with one click.
      </p>

      {/* Legal links */}
      <nav className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
        <a href="/privacy" className="hover:text-foreground">Privacy Policy</a>
        <span aria-hidden="true" className="text-foreground/30">·</span>
        <a href="/terms" className="hover:text-foreground">Terms</a>
        <span aria-hidden="true" className="text-foreground/30">·</span>
        <a href="/disclaimer" className="hover:text-foreground">Disclaimer</a>
        <span aria-hidden="true" className="text-foreground/30">·</span>
        <a href="/coffee-ritual" className="hover:text-foreground">Coffee Ritual</a>
      </nav>

      {/* Contact */}
      <p className="mt-6">
        Questions? Just write to me at{" "}
        <a
          href="mailto:eliza@elizareedwellness.com"
          className="underline underline-offset-4 hover:text-foreground"
        >
          eliza@elizareedwellness.com
        </a>
        . I read every message myself.
      </p>

      {/* Copyright */}
      <p className="mt-8 text-xs text-foreground/75">
        © {new Date().getFullYear()} Eliza Reed Wellness. All rights reserved.
      </p>

      {/* Emotional line */}
      <p className="mt-6 font-script text-xl text-primary">
        Written gently, with care — for every woman who feels unseen.
      </p>
    </div>
  </footer>
);

export default Footer;
